import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {OG_PATH} from "@/content";

const serviceId = 1
const slug = 'sydney-switchboard-upgrades-and-repairs';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {
    const metaTags : MetaTagsProps =  {
        title: "Switchboard Upgrades & Repairs",
        description: "Modernizing or repairing switchboards to handle increased electrical loads and ensure safety.",
        keywords: "switchboard upgrades Sydney, switchboard repairs Sydney, electrical switchboard services, licensed electricians Sydney, switchboard replacement, safe switchboard installation, professional electricians Sydney",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Switchboard Upgrades & Repairs',
    description: 'Modernizing or repairing switchboards to handle increased electrical loads and ensure safety.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
